<div class="container home">

  <div class="grid">
    <div class="col-12">
      <div class="home-main-box">
        <div class="home-intro">
          <h1 #homeTitle class="home-title" [style.font-size.px]="homeTitleFontSizePx">{{ 'TRANSLATE.HI.WELCOME.TO.FORD.PROTECT' | translate }}</h1>
        </div>

        <div class="home-main-content">
          <div class="home-actions">
            @if (isLoadingPermissions) {
              @for (item of [1, 2, 3]; track item) {
                <div class="home-action-item home-action-item--loading" aria-hidden="true">
                  <div class="home-button-plan home-button-plan--skeleton">
                    <div class="home-apply-align">
                      <span class="home-icon-wrap home-icon-wrap--skeleton"></span>
                      <span class="home-button-label home-button-label--skeleton"></span>
                    </div>
                  </div>
                </div>
              }
            }

            @if (isScreenSales === true || isScreenSalesTelemarketing === true) {
              <div class="home-action-item">
                <button type="button" class="home-button-plan home-button-plan--sales" (click)="salesPermissions()">
                  <div class="home-apply-align">
                    <span class="home-icon-wrap">
                      <i class="fas fa-file home-icon"></i>
                    </span>
                    <span class="home-button-label">{{ 'TRANSLATE.GENERATE.NEW.CONTRACT' | translate }}</span>
                  </div>
                </button>
              </div>
            }

            @if (isScreenContractSearch === true || isScreenContractSearchDealer === true) {
              <div class="home-action-item">
                <button type="button" class="home-button-plan home-button-plan--search" (click)="dealerPermissions()">
                  <div class="home-apply-align">
                    <span class="home-icon-wrap">
                      <i class="fas fa-search fa-flip-horizontal home-icon"></i>
                    </span>
                    <span class="home-button-label">{{ 'TRANSLATE.CONSULT.CONTRACTS' | translate }}</span>
                  </div>
                </button>
              </div>
            }

            <div class="home-action-item">
              <button type="button" class="home-button-plan home-button-plan--info" routerLink="/information">
                <div class="home-apply-align">
                  <span class="home-icon-wrap">
                    <i class="fas fa-info home-icon"></i>
                  </span>
                  <span class="home-button-label">{{ 'TRANSLATE.INFORMATION' | translate}}</span>
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>